export function getErrorMsg(response) {
    if (response) {
        if (response.data) {
            if (response.data.error) {
                if (response.data.error.error_description) return response.data.error.error_description;
                else if (response.data.error.errordesc) return response.data.error.errordesc;
                else if (response.data.error.errorDesc) return response.data.error.errorDesc;
                return "Something went wrong";
            }
            return "Something went wrong, no error";
        }
        return "Something went wrong, no data";
    }
    return "Something went wrong, no response";
}

export function getErrorCode(response) {
    if (response) {
        if (response.data) {
            if (response.data.error) {
                if (response.data.error.errorCode) return response.data.error.errorCode;
                return "0";
            }
            return "0";
        }
        return "0";
    }
    return "0";
}